import React from 'react';

export const FormField = ({
  label,
  children,
  error,
  id,
  required = false,
  className = '',
}) => (
  <div>
    <label
      htmlFor={id}
      className={`block text-left text-xs font-medium text-gray-400 mb-1 ${className}`}
    >
      {label}
      {required && <span className="text-gray-400 ml-1">*</span>}
    </label>
    {children}
    {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
  </div>
);
